// Копіювання адреси контракту в буфер обміну
function copyAddr() {
    const addr = "0x0a2dEEec5Db00294c063a3319E1a9060c0f06dF8";
    const notification = document.getElementById("notification");
    navigator.clipboard.writeText(addr).then(()=>{
        notification.classList.add("show");
        setTimeout(()=>{
            notification.classList.remove("show");
        }, 3000); // Приховати сповіщення через 3 секунди
    });
}
// Автоматичне оновлення року в футері
document.getElementById("y").textContent = new Date().getFullYear();
// Плавна прокрутка з урахуванням фіксованого меню
document.addEventListener("DOMContentLoaded", function() {
    // Висота фіксованого header
    const getHeaderHeight = ()=>{
        const header = document.querySelector("header");
        return header ? header.offsetHeight : 120;
    };
    // Обробка кліків по якорним посиланням в меню
    const menuLinks = document.querySelectorAll('a[href^="#"]');
    menuLinks.forEach((link)=>{
        link.addEventListener("click", function(e) {
            e.preventDefault();
            const targetId = this.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                const headerHeight = getHeaderHeight();
                const targetPosition = targetElement.offsetTop - headerHeight - 20; // +20px додатковий відступ
                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth"
                });
                // Оновлюємо URL без прокрутки
                history.pushState(null, null, `#${targetId}`);
            }
        });
    });
    // Обробка URL з якорем при завантаженні сторінки
    function handleInitialHash() {
        if (window.location.hash) {
            const targetId = window.location.hash.substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) // Невелика затримка для завантаження сторінки
            setTimeout(()=>{
                const headerHeight = getHeaderHeight();
                const targetPosition = targetElement.offsetTop - headerHeight - 20;
                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth"
                });
            }, 100);
        }
    }
    // Викликаємо при завантаженні
    handleInitialHash();
    // Обробка зміни хешу в URL (кнопки назад/вперед)
    window.addEventListener("hashchange", function() {
        handleInitialHash();
    });
});
// Налаштування мобільного меню
function setupMobileMenu() {
    const toggleBtn = document.querySelector(".menu-toggle");
    const mobileMenu = document.querySelector(".mobile-menu");
    toggleBtn.addEventListener("click", ()=>{
        mobileMenu.classList.toggle("is-open");
        toggleBtn.classList.toggle("is-active");
    });
    // Закриття меню при кліку на посилання
    mobileMenu.querySelectorAll("a.btn").forEach((link)=>{
        link.addEventListener("click", ()=>{
            mobileMenu.classList.remove("is-open");
            toggleBtn.classList.remove("is-active");
        });
    });
}
// Виклик функцій при завантаженні сторінки
window.addEventListener("load", ()=>{
    setupMobileMenu();
});

//# sourceMappingURL=boltvita_token.358a3ecb.js.map
